import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const MenuIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>253列表视图、菜单</title>
      <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="home-h5" transform="translate(-360.000000, -113.000000)" fill="currentColor" fillRule="nonzero">
          <g id="编组-34" transform="translate(0.000000, 99.000000)">
            <g id="253列表视图、菜单" transform="translate(360.000000, 14.000000)">
              <rect id="矩形" opacity="0" x="0" y="0" width="16" height="16"></rect>
              <path
                d="M14,4 L2,4 L2,2 L14,2 L14,4 Z M14,7 L2,7 L2,9 L14,9 L14,7 Z M14,12 L2,12 L2,14 L14,14 L14,12 Z"
                id="形状"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </span>
);

export default MenuIcon;
